<template>
  <div class="post-container">
    <div class="post-header">
      <div class="owner-container">
        <FriedSkeleton :type="SkeletonType.Avatar" />
        <div class="name-container">
          <FriedSkeleton :type="SkeletonType.H4" />
        </div>
      </div>
    </div>
    <FriedSkeleton :type="SkeletonType.Paragraph" :rows="2" />
    <FriedSkeleton :type="SkeletonType.Paragraph" :rows="3" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SkeletonType } from '@getaccept/fried-tofu';

export default defineComponent({
  setup() {
    return {
      SkeletonType,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '../../feed/scss/post-details';
</style>
